/*
 * This contains all the splashback messages
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  none: {
    id: 'cwt.translations.noSplashback',
    defaultMessage: 'No splashback',
  },
  wallPanel: {
    id: 'cwt.translations.wallPanel',
    defaultMessage: 'Wall panel',
  },
  wallEdgingStrip: {
    id: 'cwt.translations.wallEdgingStrip',
    defaultMessage: 'Wall edging strip',
  },
  wallEdgingStripCustomizable: {
    id: 'cwt.translations.wallEdgingStripCustomizable',
    defaultMessage: 'Wall edging strip customizable',
  },
});
